<template>
  <div class="bg auth-screen">
    <div class="container pt-80">
      <div class="card">
        <div class="card-body">
          <h2 class="card-title">Get a Verification Code</h2>
          <div class="card-description">
            To create your username, first enter your email below and obtain your verification code.
          </div>
          <form>
            <div class="form-group">
              <label>Email</label>
              <input
                type="email"
                v-validate="'required|email'"
                name="email"
                :class="{
                  input: true,
                  'is-danger': errors.has('email'),
                  'is-success': !errors.has('email')
                }"
                class="form-control form-control-lg"
                v-model="user.email"
                placeholder="Enter your email address"
                required
              />
              <span v-show="errors.has('email')" class="text-danger">{{ errors.first("email") }}</span>
            </div>
            <p class="text-danger" v-if="errorMsg">{{ errorMsg }}</p>
            <div class="form-group">
              <div>
                <button type="submit" class="btn btn-primary btn-block" v-on:click.prevent="requestUsername" :disabled="errors.any() || !isCompleted">
                  Send Instructions
                </button>
              </div>
            </div>
          </form>
          <div class="footer-links">
            <router-link :to="{ name: 'login' }">Back to sign in</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "GetCreateUsernameLink",
  data() {
    return {
      user: {
        email: ""
      },
      formErrors: false,
      errorMsg: null
    };
  },
  watch: {
    user: {
      handler() {
        this.errorMsg = null;
      },
      deep: true
    }
  },
  computed: {
    isCompleted() {
      return this.user.email != "";
    }
  },
  mounted() {
    this.userLogout();
  },
  methods: {
    ...mapActions(["userLogout"]),
    requestUsername() {
      this.$api
        .getTokenToCreateUsername({
          email: this.user.email
        })
        .then(
          response => {
            if (response.body.message) {
              const paramsObj = {
                token: response.body.message.token
              };
              if (response.body.message.phone_number && response.body.message.phone_number != "") {
                paramsObj.mobile = response.body.message.phone_number;
              }

              this.$router.push({
                name: "verify-identity",
                params: paramsObj,
                query: {
                  tokenType: "CREATE_USERNAME_OTP"
                }
              });
            }
          },
          error => {
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while requesting to change the password";
          }
        );
    }
  }
};
</script>

<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
